


























































import { Component, Prop, Vue } from 'vue-property-decorator';
import InfoIcon from '@/components/icons/Info.vue';

type TriggerPosition = 'left' | 'right';

export interface CardsSecondaryWallet {
  counter: string;
  label: string;
  fractionDigits?: number;
  prefixSymbol?: string;
  tooltipText?: string;
  periodLabel?: string;
}

@Component({
  components: {
    InfoIcon
  }
})
export default class WalletSecondary extends Vue {
  @Prop({ default: () => [] }) cards!: Array<CardsSecondaryWallet>;
  @Prop({ default: () => false }) useSpaceBetweenPrefixAndValue?: boolean;

  observer: IntersectionObserver | null = null;

  triggerVisibility: Record<TriggerPosition, boolean> = {
    left: false,
    right: false
  };

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  mounted() {
    if (!this.isMobileDevice) return;

    const containerId = '#customer-wallet__secondary';
    const triggerClass = '.customer-wallet__trigger';

    const targets = document.querySelectorAll<HTMLElement>(
      `${containerId} > ${triggerClass}`
    );

    this.observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          const position = entry.target.getAttribute(
            'data-position'
          ) as TriggerPosition;

          this.triggerVisibility[position] =
            !entry.isIntersecting && !!position;
        }
      },
      {
        root: document.querySelector(containerId),
        threshold: 0
      }
    );

    for (const target of targets) {
      this.observer.observe(target);
    }
  }

  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  }
}
